import React from 'react'
import styled from 'styled-components'
import IS_ERROR from '../../images/error.png'

export const Error = () => {
  return (
    <ErrorPageWrap>
      <img src={IS_ERROR} alt="something went wrong" />
      <h4>Something went wrong!</h4>
    </ErrorPageWrap>
  )
}


const ErrorPageWrap = styled.div`
  text-align: center;
  text-transform: lowercase;
  font-size: 18px;

  img{
    border-radius: 10%;
    width: 100%;
    height: auto;
  }
`